<template>
  <v-container>
    <v-slide-y-transition mode="out-in">
      <v-form ref="form" v-model="valid" lazy-validation>
        <v-layout row wrap="">
          <v-flex md8 offset-md2>
            <v-card>
              <v-toolbar flat color="grey lighten-3">
                <v-btn icon @click="cancel()">
                  <v-icon>arrow_back</v-icon>
                </v-btn>
                <v-toolbar-title>{{ title }}</v-toolbar-title>
              </v-toolbar>
              <v-card-text>
                <v-select
                  :items="userTypes"
                  v-model="user.securityClass"
                  label="User Type"
                  item-text="label"
                  item-value="value"
                  required class="required"
                ></v-select>
                <v-flex md12>
                  <v-text-field v-model="user.email" :rules="emailRules" label="Email" required class="required"></v-text-field>
                </v-flex>
                <v-flex md12>
                  <v-text-field
                    v-model="user.phoneNumber"
                    :rules="requiredRules"
                    label="Phone Number"
                    required class="required"
                    mask="phone"
                  ></v-text-field>
                </v-flex>
                <v-flex md12>
                  <v-text-field
                    v-if="!(this.userId)"
                    v-model="user.password"
                    label="Password"
                    :type="'password'"
                    :rules="passwordRules"
                    required class="required"
                  ></v-text-field>
                  <v-text-field
                    v-if="this.userId"
                    v-model="user.password"
                    label="Password"
                    :type="'password'"
                  ></v-text-field>
                </v-flex>
                <v-flex md12>
                  <v-text-field
                    v-if="!(this.userId)"
                    label="Confirm Password"
                    :type="'password'"
                    required class="required"
                    :rules="passwordConfirmationRules"
                  ></v-text-field>
                  <v-text-field
                    v-if="this.userId"
                    label="Confirm Password"
                    :type="'password'"
                    :rules="passwordConfirmationNotReqRules"
                  ></v-text-field>
                </v-flex>
                <v-flex md12>
                  <v-text-field
                    v-model="user.firstName"
                    :rules="nameRules"
                    label="First Name"
                    required class="required"
                  ></v-text-field>
                </v-flex>
                <v-flex md12>
                  <v-text-field v-model="user.middleInitial" label="Middle Initial" maxlength="1"></v-text-field>
                </v-flex>
                <v-flex md12>
                  <v-text-field
                    v-model="user.lastName"
                    :rules="nameRules"
                    label="Last Name"
                    required class="required"
                  ></v-text-field>
                </v-flex>
                <v-flex md12>
                  <v-text-field
                    v-model="user.address1"
                    label="Address 1"
                  ></v-text-field>
                </v-flex>
                <v-flex md12>
                  <v-text-field v-model="user.address2" label="Address 2"></v-text-field>
                </v-flex>
                <v-flex md12>
                  <v-text-field v-model="user.city" label="City"></v-text-field>
                </v-flex>
                <v-flex md12>
                  <v-text-field
                    v-model="user.postalCode"
                    label="Postal Code"
                    mask="#####"
                  ></v-text-field>
                </v-flex>
                <v-flex md12>
                  <v-text-field v-model="user.state" label="State" ></v-text-field>
                </v-flex>
                <v-flex md12>
                  <v-text-field
                    v-model="user.country"
                    label="Country"
                  ></v-text-field>
                </v-flex>
<!--
                <v-flex md12>
                  <v-text-field
                    v-model="user.dateOfBirth"
                    label="Date of Birth (YYYY-MM-DD)"
                    :rules="birthdayRules"
                    return-masked-value
                    mask="####-##-##"
                  ></v-text-field>
                </v-flex>
-->
              </v-card-text>
              <v-card-actions>
                <v-btn
                  v-if="userId && !isLoggedInUser"
                  flat
                  color="red"
                  @click="dialog = true"
                >Suspend</v-btn>
                <v-spacer></v-spacer>
                <v-btn flat color="blue" :disabled="!valid" @click="save">Save</v-btn>
              </v-card-actions>
            </v-card>
          </v-flex>
        </v-layout>
      </v-form>
    </v-slide-y-transition>
    <v-dialog v-model="dialog" max-width="290">
      <v-card>
        <v-card-title class="headline">Delete?</v-card-title>
        <v-card-text>Are you sure you want to suspend this user?</v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="green darken-1" flat="flat" @click="suspend">Yes</v-btn>
          <v-btn color="green darken-1" flat="flat" @click="dialog = false">No</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
import RestService from '../services/RestService';
import * as Sentry from '@sentry/browser';

const service = new RestService();

export default {
  name: 'User',
  props: {
    userId: String
  },
  data() {
    return {
      dialog: false,
      title: 'Create New User',
      isLoggedInUser: false,
      loggedInUser: {},
      access: {},
      user: {},
      userTypes: [],
      valid: false,
      nameRules: [
        v => !!v || 'Name is required',
        v => (v && v.length <= 10) || 'Name must be less than 10 characters'
      ],
      emailRules: [
        v => !!v || 'E-mail is required',
        v => /.+@.+/.test(v) || 'E-mail must be valid'
      ],
      requiredRules: [v => !!v || 'Required'],
      birthdayRules: [
        v => !!v || 'Required',
        v => (v && v.length == 10) || 'Date of Birth must be valid'
      ],
      passwordRules: [v => !!v || 'Password is required'],
      passwordConfirmationRules: [
        v => !!v || 'Confirm Password is required',
        v => v == this.user.password || 'Passwords must match'
      ],
      passwordConfirmationNotReqRules: [
        v => v == this.user.password || 'Passwords must match'
      ]
    };
  },
  methods: {
    suspend() {
      service
        .deleteUserById(this.userId)
        .then(response => {
          this.$router.push('/');
        })
        .catch(e => {
          console.log(e);
          Sentry.captureException(e);
        });
    },
    cancel() {
      this.$router.push('/');
    },
    save() {
      if (this.$refs.form.validate()) {
        console.log(this.user);
        service
          .saveUser(this.user)
          .then(response => {
            this.$router.push('/');
          })
          .catch(e => {
            console.log(e);
            Sentry.captureException(e);
          });
      }
    }
  },
  created() {
    this.user = {};
    this.loggedInUser = this.$store.getters['auth/user'];
    this.access = this.$store.getters['auth/access'];

    // get User Types
    service
      .getDropdown('SecurityMask')
      .then(response => {
        console.log(response);
        if (response.data.body && response.data.body.length > 0) {
          for (let i=0; i< response.data.body.length; i++) {
            if(response.data.body[i].dropdownOrder <= this.loggedInUser.securityClass) {
              this.userTypes.push({'label':response.data.body[i].dropdownValue,'value':response.data.body[i].dropdownOrder});
            }
          }
        }
      })
      .catch(e => {
        console.log(e);
        Sentry.captureException(e);
      });
      
    if (this.userId && this.loggedInUser.UserID != this.userId) {
      this.title = 'Edit User';
      this.isLoggedInUser = false;
      service
        .getUser(this.userId)
        .then(response => {
          if (response.data.body && response.data.body.length > 0) {
            this.user = response.data.body[0];
          }
        })
        .catch(e => {
          console.log(e);
          Sentry.captureException(e);
        });
    } else if (this.userId) {
      this.isLoggedInUser = true;
      this.title = 'User Profile';
      service
        .getUser(this.userId)
        .then(response => {
          if (response.data.body && response.data.body.length > 0) {
            this.user = response.data.body[0];
          }
        })
        .catch(e => {
          console.log(e);
          Sentry.captureException(e);
        });
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
h3 {
  margin: 40px 0 0;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: #42b983;
}
.card {
  background-color: #fff;
}
.status-failed {
  background-color: $color-status-failed;
  border-color: $color-status-failed;
}
.status-inactive {
  background-color: $color-status-inactive;
  border-color: $color-status-inactive;
}
.status-good {
  background-color: $color-status-good;
  border-color: $color-status-good;
}
.user-info {
  height: 100%;
  flex-direction: column;
  display: flex;
  justify-content: center;
  cursor: pointer;
}
.name {
  font-weight: 700;
  font-size: 20px;
  text-transform: uppercase;
}

</style>
